import { render, staticRenderFns } from "./failure.vue?vue&type=template&id=0843c988&scoped=true"
import script from "./failure.vue?vue&type=script&lang=js"
export * from "./failure.vue?vue&type=script&lang=js"
import style0 from "./failure.vue?vue&type=style&index=0&id=0843c988&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0843c988",
  null
  
)

export default component.exports